import React, { Component } from 'react';
import { connect } from 'react-redux';
import cookie from 'react-cookies';
import actions from '../redux/actions';

class PublicationReg extends Component {
  componentWillMount() {
    if (!this.props.fields.type || this.props.fields.type === '') {
      this.props.router.push('/');
    }
    cookie.remove('signupPlan');
  }

  componentWillUnmount() {
    this.props.resetAttribute();
  }

  render() {
    return <div className="copyright-reg">{this.props.children}</div>;
  }
}

const mapStateToProps = (state) => ({
  fields: state.coreg.fields,
});

const mapDispatchToProps = (dispatch) => ({
  resetAttribute: () => {
    dispatch(actions.resetCoregAttribute());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PublicationReg);



// WEBPACK FOOTER //
// src/pages/PublicationReg.jsx